// Monitor de pressao de braco YK-IBPA1 (Flagtrip / chip yichip).
//
// Servico de 128 bits que so apareceu no nRF Connect — o Chrome nao entrega UUID
// que nao tenha sido declarado antes, e nao ha como adivinhar. Protocolo
// decifrado na Etapa 0 e conferido contra o visor: 115/75, pulso 96.
//
// Ao conectar, o aparelho despeja SOZINHO as 8 ultimas medicoes da memoria.
// Isso e bom (nada se perde numa queda de conexao) e exige deduplicacao na
// gravacao — ver a chave `leitura_sem_duplicata` no schema.

export const YK_SERVICO = 'cdeacd80-5235-4c07-8846-93a37ee6b86d';
export const YK_CARACTERISTICA = 'cdeacd81-5235-4c07-8846-93a37ee6b86d';

export type QuadroYk =
  | { tipo: 'manguito'; pressao: number }
  | {
      tipo: 'resultado';
      sistolica: number;
      diastolica: number;
      pulso: number;
      /** 0 = medicao que acabou de acontecer; 1..7 = memoria do aparelho. */
      indice: number;
      /** Data/hora do RELOGIO DO APARELHO — costuma estar errado. */
      medidoEmAparelho: Date;
      daMemoria: boolean;
    }
  | { tipo: 'desconhecido'; comando: number };

export function decodificarYk(dados: Uint8Array): QuadroYk | null {
  if (dados.length < 3) return null;
  const comando = dados[0]!;

  // Pressao do manguito durante a inflacao, em tempo real.
  if (comando === 0x80) return { tipo: 'manguito', pressao: dados[2]! };

  if (comando === 0x81 && dados.length >= 11) {
    const indice = dados[5]!;
    return {
      tipo: 'resultado',
      sistolica: dados[1]!,
      diastolica: dados[2]!,
      pulso: dados[3]!,
      indice,
      medidoEmAparelho: new Date(2000 + dados[6]!, dados[7]! - 1, dados[8]!, dados[9]!, dados[10]!),
      daMemoria: indice !== 0,
    };
  }

  return { tipo: 'desconhecido', comando };
}
